import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import RoomShowcase from './components/RoomShowcase';
import RestaurantSection from './components/RestaurantSection';
import FacilitySection from './components/FacilitySection';
import FeaturedArticles from './components/FeaturedArticles';
import CTASection from './components/CTASection';
import { aboutInfo } from '@/mocks/hotelData';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="WebSite" data={{
        name: aboutInfo.brandName,
        alternateName: aboutInfo.brandNameEn,
        url: 'https://www.grandlisboa.com',
        description: aboutInfo.description,
      }} />
      <SchemaOrg type="Organization" data={{
        name: aboutInfo.brandName,
        url: 'https://www.grandlisboa.com',
        description: aboutInfo.description,
        address: { '@type': 'PostalAddress', addressLocality: '澳门', streetAddress: aboutInfo.address },
        telephone: aboutInfo.phone,
        email: aboutInfo.email,
      }} />
      <SchemaOrg type="WebPage" data={{
        name: '新葡京酒店官方网站 - 首页',
        description: '新葡京酒店是澳门地标级豪华酒店，集顶级客房、米其林餐厅、娱乐设施于一体，为您提供极致奢华住宿体验。',
        url: 'https://www.grandlisboa.com',
        isPartOf: { '@type': 'WebSite', name: aboutInfo.brandName, url: 'https://www.grandlisboa.com' },
      }} />

      <header>
        <Navbar />
      </header>

      <main>
        <HeroSection />
        <RoomShowcase />
        <RestaurantSection />
        <FacilitySection />
        <FeaturedArticles />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}